"use strict";
(function (Drupal) {
    Drupal.behaviors.resetTopLevelMenuChevrons = {
        attach: function (context) {
            const elements = document.querySelectorAll('.js-top-level-menu-item');
            // Check if elements is an array of HTMLelements
            if (elements instanceof NodeList) {
                // OR: const elementArray = [...elements];
                elements.forEach(function (element) {
                    if (element instanceof HTMLElement) {
                        // Get the svgs inside of element(white chevron on hover)
                        const chevronSvgs = element.querySelectorAll('svg');
                        // Reset the rotation to 0 degrees
                        if (chevronSvgs) {
                            chevronSvgs.forEach((svg) => {
                                svg.style.transform = 'rotate(0deg)';
                            });
                        }
                    }
                });
            }
        },
    };
})(Drupal);
